// Action type for SetLayoutAction
import {
    FavouritControlsInterface,
    GridControlsInterface,
    MainControlsInterface,
    MenuControlsInterface,
    ProfileControlsInterface,
    SearchControlsInterface,
    VoidInterface,
} from 'types/functions';

export interface SetActiveToolsReturn {
    type: string;
    payload: object;
}

export interface SetLayoutAction {
    (options: any): SetActiveToolsReturn;
}

export const setLayoutAction: SetLayoutAction = (options) => {
    return {
        type: 'SET_LAYOUT',
        payload: options,
    };
};

// Action type for SetSwitchAction

export interface SetSwitchReturn {
    type: string;
    payload: { key: string; value: object };
}

export interface SetSwitchAction {
    (key: string, value: object): SetSwitchReturn;
}

export const setSwitchAction: SetSwitchAction = (key, value) => {
    return {
        type: 'SET_SWITCH',
        payload: { key, value },
    };
};

// Action type for SetGridSettingsAction

export interface SetGridSettingsReturn {
    type: string;
    payload: SetGridSettingsReturn;
}

export interface SetGridSettingsAction {
    (gridSettings, save?: boolean): SetGridSettingsReturn;
}

export const setGridSettingsAction: SetGridSettingsAction = (gridSettings, save = true) => {
    return {
        type: 'SET_GRID_SETTINGS',
        payload: gridSettings,
        save: save,
    };
};

// Action type for SetLayerAction

export interface SetLayerReturn {
    type: string;
    payload: { key: string; value: object };
}

export interface SetLayerAction {
    (key: string, value: object): SetLayerReturn;
}

export const setLayerAction: SetLayerAction = (key, value) => {
    return {
        type: 'SET_LAYER',
        payload: { key, value },
    };
};

// Action type for SetPilotagePlanSettingAction

export interface SetPilotagePlanSettingReturn {
    type: string;
    payload: { key: string; value: object };
}

export interface SetPilotagePlanSettingAction {
    (key: string, value: object): SetPilotagePlanSettingReturn;
}

export const setPilotagePlanSettingAction: SetPilotagePlanSettingAction = (key, value) => {
    return {
        type: 'SET_PILOTAGE_PLAN_SETTING',
        payload: { key, value },
    };
};

export interface SetDisabledToolsReturn {
    type: string;
    payload: string[];
}

// Action type for SetDisabledToolsAction
export interface SetDisabledToolsAction {
    (disabledTools: string[]): SetDisabledToolsReturn;
}

export const setDisabledToolsAction: SetDisabledToolsAction = (disabledTools) => {
    return {
        type: 'SET_DISABLED_TOOLS',
        payload: disabledTools,
    };
};

// Action type for set search object

export interface SetSearchObjectReturn {
    type: string;
    payload: object;
}

export interface SetSearchObjectAction {
    (searchObject: object): SetSearchObjectReturn;
}

export const setSearchObjectAction: SetSearchObjectAction = (searchObject) => {
    return {
        type: 'SET_SEARCH_OBJECT',
        payload: searchObject,
    };
};

// Action type for set highlight object

export interface SetHighlightObjectReturn {
    type: string;
    payload: object;
}

export interface SetHighlightObjectAction {
    (highlightObject: object): SetHighlightObjectReturn;
}

export const setHighlightObjectAction: SetHighlightObjectAction = (highlightObject) => {
    return {
        type: 'SET_HIGHLIGHT_OBJECT',
        payload: highlightObject,
    };
};

// Action type for SetOpendMenuAction

export interface SetOpendMenuReturn {
    type: string;
    payload: boolean;
}

export interface SetOpendMenuAction {
    (opendMenu: boolean): SetOpendMenuReturn;
}

export const setOpendMenuAction: SetOpendMenuAction = (opendMenu) => {
    return {
        type: 'SET_OPENED_MENU',
        payload: opendMenu,
    };
};

export interface SetSystemReturn {
    type: string;
    payload: object;
    save: boolean;
}

export interface SetSystemAction {
    (system: object, save: boolean): SetSystemReturn;
}

export const setSystemAction: SetSystemAction = (system, save) => {
    return {
        type: 'SET_SYSTEM',
        payload: system,
        save: save,
    };
};

// Action type for SetOpenModelFunction

export interface SetOpenModelFunctionReturn {
    type: string;
    payload: (key: string, index?: number, data?: unknown, type?: string, action?: unknown) => void;
}

export interface SetOpenModelFunctionAction {
    (openModelFunction: (...args: any[]) => any): SetOpenModelFunctionReturn;
}

export const setOpenModelFunctionAction: SetOpenModelFunctionAction = (openModelFunction) => {
    return {
        type: 'SET_OPEN_MODEL_FUNCTION',
        payload: openModelFunction,
    };
};
// Action type for SetOpenModelFunction

export interface IsAnyOpendModelFunctionReturn {
    type: string;
    payload: () => boolean;
}

export interface IsAnyOpendModelFunctionAction {
    (isAnyOpendModelFunction: () => boolean): IsAnyOpendModelFunctionReturn;
}

export const isAnyOpenModelFunctionAction: IsAnyOpendModelFunctionAction = (isAnyOpendModelFunction) => {
    return {
        type: 'SET_IS_OPENED_MODEL_FUNCTION',
        payload: isAnyOpendModelFunction,
    };
};
// Action type for SetCloseModelFunction

export interface SetCloseModelFunctionReturn {
    type: string;
    payload: VoidInterface;
}

export interface SetCloseModelFunctionAction {
    (closeModelFunction: (...args: any[]) => any): SetCloseModelFunctionReturn;
}

export const setCloseModelFunctionAction: SetCloseModelFunctionAction = (closeModelFunction) => {
    return {
        type: 'SET_CLOSE_MODEL_FUNCTION',
        payload: closeModelFunction,
    };
};

// Action type for SetCloseToolFunction

export interface SetCloseToolFunctionReturn {
    type: string;
    payload: (key: string, index?: number, data?: unknown, type?: string, action?: unknown) => void;
}

export interface SetCloseToolFunctionAction {
    (closeToolFunction: (...args: any[]) => any): SetCloseToolFunctionReturn;
}

export const setCloseToolFunctionAction: SetCloseToolFunctionAction = (closeToolFunction) => {
    return {
        type: 'SET_CLOSE_TOOL_FUNCTION',
        payload: closeToolFunction,
    };
};

// Return type for SetSearchControlsAction
export interface SetSearchControlsReturn {
    type: string;
    payload: object;
}

export interface SetSearchControlsAction {
    (searchControls: SearchControlsInterface): SetSearchControlsReturn;
}

export const setSearchControlsAction: SetSearchControlsAction = (searchControls) => {
    return {
        type: 'SET_SEARCH_CONTROLS',
        payload: searchControls,
    };
};

// Return type for SetLayerControlsAction
export interface SetLayerControlsReturn {
    type: string;
    payload: object;
}

export interface SetLayerControlsAction {
    (layerControls: object): SetLayerControlsReturn;
}

export const setLayerControlsAction: SetLayerControlsAction = (layerControls) => {
    return {
        type: 'SET_LAYER_CONTROLS',
        payload: layerControls,
    };
};

// Return type for SetFavouritControlsAction
export interface SetFavouritControlsReturn {
    type: string;
    payload: FavouritControlsInterface;
}

export interface SetFavouritControlsAction {
    (favouritControls: FavouritControlsInterface): SetFavouritControlsReturn;
}

export const setFavouritControlsAction: SetFavouritControlsAction = (favouritControls) => {
    return {
        type: 'SET_FAVOURIT_CONTROLS',
        payload: favouritControls,
    };
};

// Return type for SetGridControlsAction
export interface SetGridControlsReturn {
    type: string;
    payload: GridControlsInterface;
    save: boolean;
}

export interface SetGridControlsAction {
    (gridControls: GridControlsInterface): SetGridControlsReturn;
}

export const setGridControlsAction: SetGridControlsAction = (gridControls, save = true) => {
    return {
        type: 'SET_GRID_CONTROLS',
        payload: gridControls,
        save: save,
    };
};

// Return type for setMenuControlsAction
export interface SetmenuControlsReturn {
    type: string;
    payload: MenuControlsInterface;
}

export interface SetMenuControlsAction {
    (menuControls: MenuControlsInterface): SetmenuControlsReturn;
}

export const setMenuControlsAction: SetMenuControlsAction = (menuControls) => {
    return {
        type: 'SET_VESSEL_CONTROLS',
        payload: menuControls,
    };
};

// Return type for SetProfileControlsAction
export interface SetProfileControlsReturn {
    type: string;
    payload: ProfileControlsInterface;
}

export interface SetProfileControlsAction {
    (profileControls: ProfileControlsInterface): SetProfileControlsReturn;
}

export const setProfileControlsAction: SetProfileControlsAction = (profileControls) => {
    return {
        type: 'SET_PROFILE_CONTROLS',
        payload: profileControls,
    };
};

// Return type for SetMetOceanChartControlsAction
export interface SetMetOceanChartControlsReturn {
    type: string;
    payload: object;
}

export interface SetMetOceanChartControlsAction {
    (metOceanChartControls: object): SetMetOceanChartControlsReturn;
}

export const setMetOceanChartControlsAction: SetMetOceanChartControlsAction = (metOceanChartControls) => {
    return {
        type: 'SET_METOCEAN_CHART_CONTROLS',
        payload: metOceanChartControls,
    };
};

// Return type for SetMainControlsAction
export interface SetMainControlsReturn {
    type: string;
    payload: MainControlsInterface;
}

export interface SetMainControlsAction {
    (mainControls: MainControlsInterface): SetMainControlsReturn;
}

export const setMainControlsAction: SetMainControlsAction = (mainControls) => {
    return {
        type: 'SET_MAIN_CONTROLS',
        payload: mainControls,
    };
};
